import { Helmet } from "react-helmet";
import { ContentWidthContainer } from "../components/ContentWidthContainer";
import { PageHeader } from "../components/PageHeader";

const FIRST_PARAGRAPH = `We may place a text file called a “cookie” in the browser files of your computer. The cookie
itself does not contain Personal Information although it will enable us to relate your use of
this site to information that you have specifically and knowingly provided. But the only
personal information a cookie can contain is information you supply yourself. A cookie can’t
read data off your hard disk or read cookie files created by other sites. BFH uses cookies to
track user traffic patterns (as described above). You can refuse cookies by turning them off
in your browser. If you’ve set your browser to warn you before accepting cookies, you
will receive the warning message with each cookie. You do not need to have cookies turned on
to use this site, however, refusing cookies may restrict the functionality of the promotions
that we offer.`;

export const CookiePolicy: React.FC = () => (
  <>
    <Helmet>
      <title>Cookie Policy - Holiday Homes for Sale</title>
      <meta name="description" content={FIRST_PARAGRAPH} />
    </Helmet>

    <PageHeader>Cookie Policy</PageHeader>
    <ContentWidthContainer>{FIRST_PARAGRAPH}</ContentWidthContainer>
  </>
);
